import { ErrorPage } from "@components/pages/ErrorPage"
import { SiteShell } from "@components/SiteShell"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/404")({
  component: () => (
    <SiteShell
      locale="ja"
      page="error404"
    >
      <ErrorPage locale="ja" />
    </SiteShell>
  ),
})
